export default "__VITE_ASSET__4bec68a9__"